import { useParams } from 'react-router-dom'

import { useZocksQuota } from '../../components/ScopedBlock/hooks'
import { useDocumentTitle } from '../../common/useDocumentTitle'

import { DELTA_TRIAL_FEATURES } from '../Plan/DeltaTrial/DeltaTrialFeatures'
import { Upsell } from '../Plan/DeltaTrial/Upsell/Upsell'

import { DocumentUploadInitialization } from './Initialization/DocumentUploadInitialization'
import { DocumentUpload } from './DocumentUpload/DocumentUpload'

export const DocumentUploadPage = () => {
  useDocumentTitle('Documents')

  const { userId = null } = useParams()

  const { isFetching: quotasFetching, hasQuota, quotaSuccess } = useZocksQuota()

  if (!quotaSuccess && quotasFetching) {
    return null
  }

  const documentSummaryEnabled = hasQuota('ai.documentSummaryAgent.value')

  if (!documentSummaryEnabled) {
    return <Upsell feature={DELTA_TRIAL_FEATURES['processDocument']} />
  }

  return (
    <div className='truly-full-size-content'>
      <DocumentUploadInitialization />
      <DocumentUpload initialContactId={userId} />
    </div>
  )
}
